import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import tags from './model/tags';
import user from './model/user';
import skin from './model/skin';
import roleRouter from './model/roleRouter';
import dictionary from './model/dictionary';

Vue.use(Vuex);
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['skin.currentSkin'],
    }),
  ],
  modules: {
    tags,
    user,
    skin,
    roleRouter,
    dictionary,
  },
});
